import React, { ReactNode } from 'react';
import { useResizeDetector } from 'react-resize-detector';
import { Wrapper } from './PopoverUI';

interface IProps {
  children: ReactNode;
  onResize: () => void;
}

export default ({ children, onResize }: IProps) => {
  // If we observe that container is changing in sizes
  // we should call onResize to update Popover position
  // to properly be shown on the screen
  const { ref } = useResizeDetector({
    onResize,
  });

  return <Wrapper ref={ref}>{children}</Wrapper>;
};
